import React, { useRef, useEffect, useState } from 'react';
import { useTheme } from 'theming';
import useStyles from './styles';
import { animated } from '@react-spring/web';
import { ClickAwayListener } from '../ClickAwayListener/ClickAwayListener';
import clsx from 'clsx';
const Modal = ({ children, setOpen, parent, customClassName = '', interpolation = {}, inlineStyles = {}, onClickAway = null, closeOnClickAway = true, }) => {
    const container = useRef(null);
    const theme = useTheme();
    const classes = useStyles({ theme });
    const [coords, setCoords] = useState({});
    useEffect(() => {
        if (parent) {
            const rect = parent.getBoundingClientRect();
            setCoords({
                left: rect.x,
                top: rect.y + window.scrollY - 35
            });
        }
    }, [parent]);
    const containerStyle = clsx({
        [classes.container]: true,
        [customClassName]: Boolean(customClassName),
    });
    const handleClickAway = e => {
        if (onClickAway)
            onClickAway(e);
        if (closeOnClickAway)
            setOpen(false);
    };
    return (React.createElement(ClickAwayListener, { onClickAway: handleClickAway, nodeToIgnore: parent },
        React.createElement(animated.div, { className: containerStyle, ref: container, style: Object.assign(Object.assign(Object.assign({}, inlineStyles), interpolation), coords) }, children)));
};
export { Modal };
//# sourceMappingURL=Modal.js.map